import auth_axios from 'src/service/axios_base/auth_axios'

const MAX_REQUESTS_COUNT = 50
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

let urlName = ''

// create new axios instance
const axios_c_for_price_and_inventory = auth_axios.create({})

/**
 * Axios Request Interceptor
 */
axios_c_for_price_and_inventory.interceptors.request.use(function (config) {
   
    urlName = config.url
    if (process.env.REACT_APP_API_TIER) {
        const tierQuery = process.env.REACT_APP_API_TIER.replace(/^\?/, '');
        urlName = urlName + (urlName.includes('?') ? '&' : '?') + tierQuery;
    }
    let d = new Date();
    let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
    config = { ...config, url: urlName }
    return new Promise((resolve, reject) => {
        let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
                PENDING_REQUESTS++
                clearInterval(interval)
                resolve(config)
            }
        }, INTERVAL_MS)
    })
});

/**
 * Axios Response Interceptor
 */
axios_c_for_price_and_inventory.interceptors.response.use(function (response) {
    let d = new Date();
    let currentTime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ":" + d.getMilliseconds();
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
}, function (error) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
});

export default axios_c_for_price_and_inventory